import { useQuery } from '@tanstack/react-query'
import { getActiveSpecialLecture } from '@/api/unitAssessment'

export const activeSpecialLectureKey = ['learner', 'me', 'special-lecture'] as const

export interface UseActiveSpecialLectureOptions {
  enabled?: boolean
  /** ms 단위. 0/undefined 면 폴링 없음(프린트 대기 화면만 사용). */
  pollInterval?: number
}

/** 학습자의 active 단원평가 특강(hard-lock 게이트). 없으면 data=null. */
export function useActiveSpecialLecture(options: UseActiveSpecialLectureOptions = {}) {
  const { enabled = true, pollInterval } = options
  return useQuery({
    queryKey: activeSpecialLectureKey,
    queryFn: getActiveSpecialLecture,
    enabled,
    staleTime: 0,
    refetchInterval: pollInterval && pollInterval > 0 ? pollInterval : false,
  })
}
